import createNumberMask from 'text-mask-addons/dist/createNumberMask'
// import emailMask from 'text-mask-addons/dist/emailMask' for email

export const textMasks = (maskType) => {
  const masks = {
    "money" : createNumberMask({
      prefix: '$',
      suffix: '',
      allowDecimal: true
    }),
    "phone": [
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
  ],
  // "email": emailMask,
  "homeSqft" : createNumberMask({
    prefix: '',
    suffix: ' sqft',
    includeThousandsSeparator: true
  }),
  "default": null
  }
  return masks[maskType] || masks["phone"];
};


export const cleanMasks = (maskType, value) => {
  const masks = {
    "money" : value.replace("$", "").split(",").join("").trim(),
    "phone": value.split("-").join("").trim(),
    // "email": emailMask,
    "homeSqft": value.replace("sqft", "").split(",").join("").trim(),
    "default": value
  }
  return masks[maskType] || masks["default"];
};
